var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("iqos-scroll-wrapper gap-row-" + _vm.barGap)},[_c('div',{ref:"scrollContainer",staticClass:"iqos-horizontal-scroll",style:({
        'height': typeof _vm.height === 'number' ? (_vm.height + "px") : _vm.height  
      }),attrs:{"id":_vm.scrollerId}},[_c('div',{staticClass:"scroller",class:{
        'pl-40': _vm.withPaddings,
        'pr-40': _vm.withPaddings,
      },style:(Object.assign({}, _vm.scrollContainerStyles,
        {'column-gap': (_vm.gap + "px")}))},[_vm._t("default")],2)]),(!_vm.noScroller)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_scroller_shown),expression:"is_scroller_shown"}],class:{
      'pl-40': _vm.withPaddings,
      'pr-40': _vm.withPaddings,
      'smart-scroll-container': true
    }},[(_vm.can_show_scroller)?_c('BaseSmartScroller',{ref:"smartScroller",attrs:{"selector":'#' + _vm.scrollerId,"element":_vm.scrollContainerDomNode},on:{"checked":function (shown) { return _vm.is_scroller_shown = shown; }}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }